"use strict";
var PolicyConfig = (function () {
    function PolicyConfig() {
    }
    return PolicyConfig;
}());
exports.PolicyConfig = PolicyConfig;
//# sourceMappingURL=D:/a/1/s/eligibility/src/rules/models/policy-config.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/rules/models/policy-config.model.js